import { partition } from "lodash";
import { User } from "~/normalizr/entities";
import { compareWithCurrentUserById } from "../../../../../EasyProjectsCommon/CurrentUserSort";
import { SortUtility } from "../../../../../utils/sort";
import { isUnnamed, Resource } from "../types";

const resNameAccessor = (item: Resource) => item.Name;
const resComparer = (a: Resource, b: Resource) => {
    // show current user as first one in the group
    let result = compareWithCurrentUserById(a.UserId, b.UserId);
    if (result === 0) {
        // and then sort by name
        result = sortByName(a, b);
    }
    return result;
};

export const sortByName = <T extends { Name?: string }>(a: T, b: T) =>
    SortUtility.sortWithLocalCompare(resNameAccessor(a), resNameAccessor(b));

export const unnamedCombiner = SortUtility.by<Resource>(
    SortUtility.placeFirstComparer(isUnnamed),
    SortUtility.nameComparer
);

export const getSortedUsers = (users: User[] = []) => users?.sort(resComparer);
export const getSortedByName = (items: Resource[] = []) => items?.sort(sortByName);

export const getCombinedUsersWithURs = (resources: Resource[]): Resource[] => {
    const [users, unnamed] = partition(resources, x => !x.UnnamedResourceId);

    return [...getSortedByName(unnamed), ...getSortedUsers(users as User[])];
};
